import { SyncStatus, UITab } from '@constants';
import { Prototype } from '@core';
import trans from 'translation';
import { KChip, KColors, KContainer, KLabel } from 'uikit';

export const getSearchField = (tabName: string) => {
  switch (tabName) {
    case trans('ar_overdue'):
    case trans('ap_overdue'):
      return [
        {
          key: trans('code'),
          label: trans('code'),
          name: 'code'
        },
        {
          key: trans('name'),
          label: trans('name'),
          name: 'name'
        },
        {
          key: trans('email'),
          label: trans('email'),
          name: 'email'
        },
        {
          key: trans('address'),
          label: trans('address'),
          name: 'address'
        },
        {
          key: trans('outstanding'),
          label: trans('outstanding'),
          name: 'outstanding'
        }
      ];

    case trans('ar_payments'):
    case trans('ap_payments'):
      return [
        {
          key: trans('code'),
          label: trans('code'),
          name: 'code'
        },
        {
          key: trans('sync_status'),
          label: trans('sync_status'),
          name: 'syncStatus'
        },
        {
          key: trans('total_amount'),
          label: trans('total_amount'),
          name: 'totalAmount'
        },
        {
          key: trans('account_receivable'),
          label: trans('account_receivable'),
          name: 'clientName'
        },
        {
          key: trans('payment_date'),
          label: trans('payment_date'),
          name: 'paymentDate'
        },
        {
          key: trans('payment_method'),
          label: trans('payment_method'),
          name: 'paymentType'
        }
      ];
  }
  return [];
};

export const renderPaymentRow = (item: any) => {
  return (
    <KContainer.View
      key={item.code}
      marginB={'0.5rem'}
      background={'#F8F9FA'}
      br={'2x'}
      padding={'0.75rem'}
    >
      <KContainer.View row alignItems>
        <KContainer.View row alignItems flex={3}>
          <KLabel.Text typo="TextMdMedium" marginR={'1.5rem'}>
            {trans('payment_code', { code: item.code })}
          </KLabel.Text>
        </KContainer.View>

        <KContainer.View row flex={1.2} dp="flex" justifyContent="flex-end">
          <KChip
            background="#DDF7F5"
            br="x"
            brW={1}
            width={70}
            height={25}
            brC="#13A89E"
            color="#13A89E"
            marginL="0.25rem"
            label={
              (item?.syncStatus === SyncStatus.Success.toUpperCase()
                ? trans('synced').toUpperCase()
                : item?.syncStatus) ?? trans('unsynced').toUpperCase()
            }
          />
        </KContainer.View>
      </KContainer.View>

      <KContainer.View row alignItems>
        <KLabel.Text typo="Text2xLgBold" marginB={'0.25rem'}>
          {Prototype.number.formatCurrency(item.totalAmount)}
        </KLabel.Text>
      </KContainer.View>

      <KContainer.View row alignItems gap={4}>
        <KLabel.Text color={'#7B809A'}>
          {trans('account_receivable')}:
        </KLabel.Text>
        <KLabel.Text
          typo="TextNmBold"
          color={KColors.primary.normal}
          isLink
          to={`/admin/clients/${item.clientId ?? item?.client?.id}`}
          target="_blank"
        >
          {item?.client?.name}
        </KLabel.Text>
      </KContainer.View>

      <KContainer.View
        row
        alignItems
        justifyContent="space-between"
        gap={3}
        marginT={'0.5rem'}
      >
        <KContainer.View row flexW="wrap" gap={4}>
          <KLabel.Text typo="TextNmNormal">
            {`${trans('payment_date')}:`}
          </KLabel.Text>
          <KLabel.Text color={KColors.primary.normal} typo="TextNmBold">
            {Prototype.date.toLocal(item.paymentDate)?.format('DD/MM/YYYY')}
          </KLabel.Text>
        </KContainer.View>

        <KContainer.View row flexW="wrap" alignItems="center" gap={4}>
          <KLabel.Text typo="TextNmNormal">
            {`${trans('payment_method')}:`}
          </KLabel.Text>
          <KLabel.Text typo="TextNmBold">
            {trans(`option.${item.paymentType?.toLowerCase()}`)}
          </KLabel.Text>
        </KContainer.View>
      </KContainer.View>
    </KContainer.View>
  );
};

export const renderOverdueRow = (item: any, tab: UITab) => {
  return (
    <KContainer.View
      key={item?.code}
      marginB={'0.5rem'}
      background={'#F8F9FA'}
      br={'2x'}
      padding={'0.75rem'}
    >
      <KContainer.View row alignItems marginB={'0.25rem'}>
        <KContainer.View row alignItems flex={3}>
          <KLabel.Text
            typo="TextNmBold"
            color={KColors.primary.normal}
            marginR={'1.5rem'}
            isLink
            to={`/admin/accounting?tab=${tab}&statementId=${item?.id}`}
            target="_blank"
          >
            {item?.code}
          </KLabel.Text>
        </KContainer.View>

        <KContainer.View row flex={1.2}>
          <KLabel.Text typo="TextNmBold" color={KColors.black}>
            {trans('credit_limit')}:{' '}
            {Prototype.number.formatCurrency(item?.creditLimit)}
          </KLabel.Text>
        </KContainer.View>
      </KContainer.View>

      <KContainer.View row alignItems>
        <KContainer.View flex={3}>
          <KLabel.Text color={'#7B809A'}>
            {trans('client_name')}:{' '}
            <KLabel.Text
              typo="TextNmBold"
              color={KColors.primary.normal}
              isLink
              to={`/admin/clients/${item?.id}`}
              target="_blank"
            >
              {item?.name}
            </KLabel.Text>
          </KLabel.Text>
        </KContainer.View>

        <KContainer.View flex={1.2}>
          <KLabel.Text typo="TextNmBold" color={KColors.secondary.normal}>
            {trans('amount_exceed')}:{' '}
            {Prototype.number.formatCurrency(item?.outstanding)}
          </KLabel.Text>
        </KContainer.View>
      </KContainer.View>
    </KContainer.View>
  );
};
